import React from 'react'
import Contact from './Contact'
import Footer from '../Footer/Footer'

const ContactPage = () => {
  return (
   <>
   <Contact/>
   <Footer/>
   </>
  )
}

export default ContactPage